<div class="unauth-container">
    <h1 class="unath-title">{{errorMessage}}!</h1>
    <i class="las la-times-circle"></i>
    <div class="unauth-content">
        <p>You are accessing an unauthorized area of the application or your session has been expired. Please go back and try again.</p>
    </div>
    <div class="unauth-buttons-container">
        <button mat-button class="unauth-buttons" (click)="goToLink(goBack)" mat-raised-button>Go Back</button>
        <button mat-button class="unauth-buttons" (click)="goToLink(matchLoginUrl
        )" mat-raised-button>MATCH Login</button>
    </div>
</div>